/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_PlanTypeCategory_PlanTypeCategoryDto } from '../models/Wealthlane_AwardService_Dtos_PlanTypeCategory_PlanTypeCategoryDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PlanTypeCategoryService {

    /**
     * @returns Wealthlane_AwardService_Dtos_PlanTypeCategory_PlanTypeCategoryDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPlanTypeCategoryPlanTypeCategoryList(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_PlanTypeCategory_PlanTypeCategoryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/plan-type-category/plan-type-category-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_PlanTypeCategory_PlanTypeCategoryDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPlanTypeCategoryReleaseTypeCategoryList(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_PlanTypeCategory_PlanTypeCategoryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/plan-type-category/release-type-category-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
